<template>
  <app-carousel
    class="md:px-4"
    controls-position="sides"
    :item-gap="0"
    :item-width="350"
    :items="list"
  >
    <template #item="{ item, index }">
      <div class="h-full p-4" :class="{ 'pl-4': index === 0 }">
        <app-card class="h-full p-8 text-black" elevated>
          <brand-testimonial class="h-full" :testimonial="item" />
        </app-card>
      </div>
    </template>
  </app-carousel>
</template>

<script lang="ts" setup>
import type { BrandTestimonialDefinition } from "~/business-areas/brand/brand.model";

defineProps<{
  list: BrandTestimonialDefinition[];
}>();
</script>
